export const MAPBOX_TOKEN =
  process.env.REACT_APP_MAPBOX_TOKEN ??
  'pk.eyJ1IjoiZ2Fic2FtbWFwYm94IiwiYSI6ImNsNnNjeGI2NDBzMW8za3BiMnBkMnByODYifQ.YMprdNwQ4uPcqnLvHz9_Aw';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  (typeof window !== 'undefined' && window.location.hostname === 'localhost' ? 'http://localhost:5001' : '');
export const APP_RELEASE_ID = process.env.REACT_APP_RELEASE_ID || 'local';

export const DEFAULT_CENTER = [11.342616, 44.494887];
export const DEFAULT_ZOOM = 6;
export const PARMA_PROVINCE_SERVICE_AREA = {
  label: 'Parma e provincia',
  center: [10.324364, 44.798737],
  bounds: [9.45, 44.35, 10.75, 45.15],
  zoom: 12.2,
  minZoom: 8.4,
};
export const PARMA_CITY_SERVICE_AREA = {
  id: 'parma',
  label: 'Parma',
  center: [10.3279, 44.8015],
  bounds: [10.23, 44.72, 10.45, 44.9],
  zoom: 12.6,
  minZoom: 10,
};
export const REFRESH_INTERVAL_MS = 15000;
export const MAP_STYLE = 'mapbox://styles/mapbox/streets-v12';
export const DEFAULT_MAP_STYLE_OPTIONS = [
  { id: 'light', label: 'Chiara', url: 'mapbox://styles/mapbox/light-v11' },
  { id: 'streets', label: 'Strade', url: 'mapbox://styles/mapbox/streets-v12' },
  { id: 'satellite', label: 'Satellite', url: 'mapbox://styles/mapbox/satellite-streets-v12' },
  { id: 'dark', label: 'Scura', url: 'mapbox://styles/mapbox/dark-v11' },
];
export const DEFAULT_ROUTE_COLOR = '#0d2bba';
export const DEFAULT_ROUTE_COLORS = {
  '1': '#b2b2b2',
  '2': '#005931',
  '3': '#f197b6',
  '4': '#2d2c86',
  '5': '#bdd143',
  '6': '#b5ddf7',
  '7': '#009d57',
  '8': '#7f2082',
  '9': '#f18805',
  '11': '#e02a88',
  '12': '#b5ddda',
  '13': '#e4003a',
  '15': '#0079c2',
  '16': '#5db500',
  '21': '#c8b700',
  '23': '#e1b600',
};

export const DEFAULT_PUBLIC_APP_CONFIG = {
  id: 'bus-tracker',
  app: {
    name: 'Bus Tracker',
    shortName: 'TPL',
    description: 'Mappa TPL con bus realtime, fermate, orari GTFS e tracciati linea.',
    language: 'it-IT',
    timezone: 'Europe/Rome',
  },
  map: {
    center: DEFAULT_CENTER,
    bounds: null,
    zoom: DEFAULT_ZOOM,
    minZoom: 5,
    style: MAP_STYLE,
    styles: DEFAULT_MAP_STYLE_OPTIONS,
  },
  serviceArea: null,
  serviceAreas: [],
  defaultServiceAreaId: '',
  operator: {
    name: 'TPL',
    shortName: 'TPL',
    website: '',
  },
  routeColors: {
    default: DEFAULT_ROUTE_COLOR,
    useGtfsColors: false,
    routes: {},
    nightRoute: {
      sourcePattern: '^1(\\d{2})$',
      displayPattern: '$1N',
      basePattern: '$1',
    },
  },
  routeCategories: {
    routes: {},
  },
  cache: {
    browserStaticTtlMs: 24 * 60 * 60 * 1000,
    vehicleRealtimeTtlMs: 10000,
  },
  features: {
    vehicleSpeed: false,
    scheduleAdherence: false,
    realtimeArrivalPredictions: false,
    arrivalCountdown: false,
    journeyPath: false,
  },
};

export const HOST_PUBLIC_APP_CONFIGS = {
  'tep.gabsam.it': {
    id: 'tep.pr.it',
    app: {
      name: 'TEP Bus Tracker',
      shortName: 'TEP',
      description: 'Mappa TEP Parma con bus realtime, fermate, orari GTFS e tracciati linea.',
    },
    map: {
      center: PARMA_PROVINCE_SERVICE_AREA.center,
      bounds: PARMA_PROVINCE_SERVICE_AREA.bounds,
      zoom: PARMA_PROVINCE_SERVICE_AREA.zoom,
      minZoom: PARMA_PROVINCE_SERVICE_AREA.minZoom,
    },
    serviceArea: PARMA_PROVINCE_SERVICE_AREA,
    serviceAreas: [PARMA_CITY_SERVICE_AREA],
    operator: {
      name: 'TEP Parma',
      shortName: 'TEP',
      website: 'https://www.tep.pr.it/',
    },
    routeColors: {
      default: DEFAULT_ROUTE_COLOR,
      useGtfsColors: false,
      routes: DEFAULT_ROUTE_COLORS,
      nightRoute: {
        sourcePattern: '^1(\\d{2})$',
        displayPattern: '$1N',
        basePattern: '$1',
      },
    },
    features: {
      vehicleSpeed: true,
      scheduleAdherence: true,
      realtimeArrivalPredictions: true,
      arrivalCountdown: true,
      journeyPath: true,
    },
  },
  'tep.tpl-tracker.app': {
    id: 'tep.pr.it',
    app: {
      name: 'TEP Bus Tracker',
      shortName: 'TEP',
      description: 'Mappa TEP Parma con bus realtime, fermate, orari GTFS e tracciati linea.',
    },
    map: {
      center: PARMA_PROVINCE_SERVICE_AREA.center,
      bounds: PARMA_PROVINCE_SERVICE_AREA.bounds,
      zoom: PARMA_PROVINCE_SERVICE_AREA.zoom,
      minZoom: PARMA_PROVINCE_SERVICE_AREA.minZoom,
    },
    serviceArea: PARMA_PROVINCE_SERVICE_AREA,
    serviceAreas: [PARMA_CITY_SERVICE_AREA],
    operator: {
      name: 'TEP Parma',
      shortName: 'TEP',
      website: 'https://www.tep.pr.it/',
    },
    routeColors: {
      default: DEFAULT_ROUTE_COLOR,
      useGtfsColors: false,
      routes: DEFAULT_ROUTE_COLORS,
      nightRoute: {
        sourcePattern: '^1(\\d{2})$',
        displayPattern: '$1N',
        basePattern: '$1',
      },
    },
    features: {
      vehicleSpeed: true,
      scheduleAdherence: true,
      realtimeArrivalPredictions: true,
      arrivalCountdown: true,
      journeyPath: true,
    },
  },
  'gtt.gabsam.it': {
    id: 'gtt.to.it',
    app: {
      name: 'GTT Bus Tracker',
      shortName: 'GTT',
      description: 'Mappa GTT Torino con bus, tram, metro, fermate, orari GTFS e tracciati linea.',
    },
    map: {
      center: [7.686856, 45.070312],
      zoom: 11.8,
    },
    operator: {
      name: 'Gruppo Torinese Trasporti',
      shortName: 'GTT',
      website: 'https://www.gtt.to.it/',
    },
    routeColors: {
      default: '#0057b8',
      useGtfsColors: true,
      routes: {},
      nightRoute: {
        sourcePattern: '^N(\\d+)$',
        displayPattern: 'N$1',
        basePattern: '$1',
      },
    },
    features: {
      vehicleSpeed: false,
      scheduleAdherence: false,
      realtimeArrivalPredictions: false,
      arrivalCountdown: false,
      journeyPath: false,
    },
  },
  'nl.tpl-tracker.app': {
    id: 'nl.ovapi',
    app: {
      name: 'NL TPL Tracker',
      shortName: 'NL TPL',
      description: 'Mappa OVapi Nederland con mezzi, fermate e orari in tempo reale.',
      language: 'nl-NL',
      timezone: 'Europe/Amsterdam',
    },
    map: {
      center: [5.291266, 52.132633],
      bounds: [3.2, 50.7, 7.25, 53.7],
      zoom: 7.2,
      minZoom: 5,
    },
    serviceArea: {
      label: 'Nederland',
      center: [5.291266, 52.132633],
      bounds: [3.2, 50.7, 7.25, 53.7],
      zoom: 7.2,
      minZoom: 5,
    },
    operator: {
      name: 'OVapi Nederland',
      shortName: 'OVapi NL',
      website: 'https://ovapi.nl/',
    },
    routeColors: {
      default: '#005eb8',
      useGtfsColors: true,
      routes: {},
      nightRoute: {
        sourcePattern: '^N(\\d+)$',
        displayPattern: 'N$1',
        basePattern: '$1',
      },
    },
    features: {
      vehicleSpeed: true,
      scheduleAdherence: true,
      realtimeArrivalPredictions: true,
      arrivalCountdown: true,
      journeyPath: false,
    },
  },
};

export const POPUP_OFFSET = {
  bottom: [0, -44],
  'bottom-left': [0, -44],
  'bottom-right': [0, -44],
  top: [0, 10],
  'top-left': [0, 10],
  'top-right': [0, 10],
  left: [10, -18],
  right: [-10, -18],
};

export const EMPTY_FEATURE_COLLECTION = {
  type: 'FeatureCollection',
  features: [],
};

export const ALL_ROUTE_PATHS_SOURCE_ID = 'all-route-paths-source';
export const ALL_ROUTE_PATHS_GLOW_LAYER_ID = 'all-route-paths-glow-layer';
export const ALL_ROUTE_PATHS_LINE_LAYER_ID = 'all-route-paths-line-layer';
export const ROUTE_CONTEXT_SOURCE_ID = 'route-context-source';
export const ROUTE_CONTEXT_GLOW_LAYER_ID = 'route-context-glow-layer';
export const ROUTE_CONTEXT_LINE_LAYER_ID = 'route-context-line-layer';
export const JOURNEY_SOURCE_ID = 'journey-source';
export const JOURNEY_WALK_LAYER_ID = 'journey-walk-layer';
export const JOURNEY_TRANSIT_LAYER_ID = 'journey-transit-layer';
export const TPL_STOPS_SOURCE_ID = 'tpl-stops-source';
export const TPL_STOPS_HIT_LAYER_ID = 'tpl-stops-hit-layer';
export const TPL_STOPS_HALO_LAYER_ID = 'tpl-stops-halo-layer';
export const TPL_STOPS_DOT_LAYER_ID = 'tpl-stops-dot-layer';
export const TPL_STOPS_ICON_LAYER_ID = 'tpl-stops-icon-layer';
export const TPL_STOPS_TRAIN_ICON_LAYER_ID = 'tpl-stops-train-icon-layer';

export const BROWSER_CACHE_DB_NAME = 'bus-tracker-cache';
export const BROWSER_CACHE_STORE_NAME = 'api-cache';
export const BROWSER_CACHE_VERSION = 1;
export const TRANSIT_CATALOG_CACHE_KEY = 'transit-catalog-v3';
export const ROUTE_PATHS_CACHE_KEY = 'route-paths-v1';
export const ROUTE_CONTEXT_CACHE_KEY_PREFIX = 'route-context-v1';
export const ADMIN_TOKEN_STORAGE_KEY = 'bus-tracker-admin-token';
export const ROUTE_CATEGORY_OPTIONS = [
  { id: '', label: 'Auto' },
  { id: 'urban', label: 'Urbana' },
  { id: 'night', label: 'Notturna' },
  { id: 'interurban', label: 'Extraurbana' },
];

// Il GTFS statico viene rivalidato giornalmente per tenere allineati orari, linee e aree.
export const STATIC_GTFS_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
